import * as yup from 'yup';

export const UrlFormSchema = yup.object().shape({
  profileLink: yup.string().required({ tx: 'errors.required' }),
});
